import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, Stack, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useFormikContext, Formik, Form, Field, FieldArray } from 'formik';

import { ButtonUI, CheckboxUI, DialogUI, FileUploadDialogUI, FormErrorUI, FormLabelUI, InputUI } from '../Interface';

const ServiceTaskChecklistDialog = ({ open, onClose, maxWidth, selectedTaskId, selectedValues }) => {
  const { values, errors } = useFormikContext();
  const [checklistData, setCheckListData] = useState([]);

  const getValueIndex = (values, id) => {
    return values.serviceTaskCheckList.findIndex((rc) => rc.id === id);
  };

  useEffect(() => {
    const filteredChecklist = values?.serviceTaskCheckList?.filter((item) => item.serviceTaskId === selectedTaskId);
    if (filteredChecklist && filteredChecklist.length > 0) {
      setCheckListData(filteredChecklist);
    } else {
      setCheckListData([]);
    }
  }, [values, selectedTaskId]);

  const handlePreview = (data) => {
    if (data instanceof File) {
      const url = URL.createObjectURL(data);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
      return;
    }
    if (data.path) {
      const url = `${process.env.REACT_APP_API_URL}/${data.path}`;
      window.open(url, '_blank');
    }
  };

  return (
    <DialogUI
      open={open}
      onClose={onClose}
      headerContent={'Checklista'}
      fullWidth={true}
      maxWidth={maxWidth}
      contentStyle={{ bgcolor: 'grey.100', p: 1 }}
    >
      <FieldArray name="serviceTaskCheckList">
        {checklistData.length > 0 ? (
          <Box mb={2}>
            <Stack spacing={2}>
              {checklistData.map((item, idx) => {
                const valueIndex = getValueIndex(values, item.id);

                return (
                  <Paper key={item.checklistId || idx} variant="outlined" sx={{ p: 1 }}>
                    <Box>
                      <Field
                        name={`serviceTaskCheckList.${valueIndex}.checked`}
                        type="checkbox"
                        as={CheckboxUI}
                        fullWidth
                        label={<FormLabelUI text={item.name} />}
                        disabled
                      />
                    </Box>
                    <Box mt={1}>
                      <Field
                        type="text"
                        name={`serviceTaskCheckList.${valueIndex}.description`}
                        as={InputUI}
                        fullWidth
                        helperText={<FormErrorUI message={errors?.serviceTaskCheckList?.[valueIndex]?.description} />}
                        InputLabelProps={{ shrink: true }}
                        multiline
                        rows={2}
                        variant="standard"
                        label={<FormLabelUI text="Megjegyzés" />}
                        disabled
                      />
                    </Box>
                    <Box mt={1}>
                      <Typography variant="subtitle2">Mellékletek </Typography>

                      <Stack component="ul" sx={{ listStyle: 'none', pl: 0, mt: 1 }} spacing={0.5}>
                        {(item.serviceTaskAttachment || []).map((f, fi) => (
                          <Box key={fi} component="li">
                            <Typography variant="caption">{f.name || 'Fájl'}</Typography>
                            <IconButton onClick={() => handlePreview(f)}>
                              <VisibilityIcon />
                            </IconButton>
                          </Box>
                        ))}
                      </Stack>
                    </Box>
                  </Paper>
                );
              })}
            </Stack>
          </Box>
        ) : (
          <Box align="center" mt={2}>
            <Typography fontWeight="bold" fontStyle="italic">
              Nincs checklist elem hozzáadva.
            </Typography>
          </Box>
        )}
      </FieldArray>
    </DialogUI>
  );
};

export default ServiceTaskChecklistDialog;
